'use strict';

var SELECTORS = {
    toggle: '.js-toggle-password-view',
    eyeOn: 'fa-eye',
    eyeOff: 'fa-eye-slash'
};

/**
 * Toggles the paired password input's visibility, swapping the eye icon and aria-pressed.
 * @param {JQuery} $toggle - The eye trigger element.
 * @returns {void}
 */
function toggleField($toggle) {
    var $input = $toggle.prev('input');
    var $icon = $toggle.find('i');
    var reveal = $input.attr('type') === 'password';
    $input.attr('type', reveal ? 'text' : 'password');
    $icon.toggleClass(SELECTORS.eyeOff, !reveal).toggleClass(SELECTORS.eyeOn, reveal);
    $toggle.attr('aria-pressed', reveal ? 'true' : 'false');
}

module.exports = {
    /**
     * Binds the show/hide eye toggle (pointer + keyboard), delegated on a stable parent.
     * @returns {void}
     */
    togglePasswordView: function () {
        $(document)
            .on('click', SELECTORS.toggle, function () {
                toggleField($(this));
            })
            .on('keydown', SELECTORS.toggle, function (e) {
                if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                    e.preventDefault();
                    toggleField($(this));
                }
            });
    }
};
